import React from 'react'

class Tags extends React.Component {
	
	constructor(props) {
		super(props)
		this.state = {
			value: ''
		}
		this.addTag = this.addTag.bind(this)
		this.handleInputChange = this.handleInputChange.bind(this)
		this.handleKeyPress = this.handleKeyPress.bind(this)
	}
	
	handleInputChange(e) {
		const target = e.target
	    const value = target.value
	
	    this.setState({
			value: value
	    });
	}
	
	addTag() {
		const { value } = this.state
		const { addTag, tags } = this.props
		
		var tag = value.toLowerCase()
		
		if (!tag) {
			return;
		}
		
		if (tags.indexOf(tag) == -1) {
			addTag(tag)
			this.setState({
				value: ''
			})
		} else {
			alert("This tag has been used already")
		}
	}
	
	handleKeyPress(e) {
		if(e.key == 'Enter'){
			this.addTag()
		}
	}
	
	render() {
		return (
			<div className="d-flex align-items-center">
				<input type="text" className="tag-input" placeholder="e.g. Delta Air" value={ this.state.value } onChange={ this.handleInputChange } onKeyPress={ this.handleKeyPress } />
				<button type="button" onClick={ this.addTag } className="btn btn-tag">Add</button>
			</div>
		)
	}
}

export default Tags


// WEBPACK FOOTER //
// ./src/components/Editor/Tags.js